import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  BlogMidCTA,
  ShortCutDisplay,
  React
};